<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Add Attachent
  <div class="pull-right">
    <a class="boxclose" (click)="onClose(false)"></a>
  </div>
</h2>
<mat-dialog-content>
  <div class="row">
    <div class="col-md-12">
      <mat-form-field class="col-md-6">
        <mat-select matNativeControl [(ngModel)]="purpose" placeholder="Purpose">
          <mat-option *ngFor="let purpose of purposeOptions" [value]="purpose.id">
            {{purpose.descValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-12">
      <form (ngSubmit)="onUploadFile()" enctype="multipart/form-data">
        <div class="col-md-6 form-group">
          <input type="file" name="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.pdf"
            (change)="onFileSelectedMethod($event)" />
        </div>
        <div *ngIf="showAlert" class="alert alert-warning col-md-12" style="color: red !important;" role="alert">
          Please select file.
        </div>
        <button mat-raised-button class="pull-right btn btn-semi-round w-40 bgBlue">
          Upload File
        </button>
      </form>
    </div>
  </div>
</mat-dialog-content>
